var mobileSwitch = 992;
var nav = $('.mxm_navigation.main .navbar-collapse');
var meta = $('header#main .mxm_navigation.inline');
var lang = $('header#main .mxm_navigation.language');
var body = $('body');

$(document).ready(function() {
    initNavClickHandler();
    initNavSearch();
    initLogout();
});

$(window).on('load', metaClone);
$(window).on('load resize', topOfMobileNav);

function topOfMobileNav() {
    if ($(window).width() < mobileSwitch) {
        nav.css('top', $('header#main').outerHeight());

        nav.css('top', $('header#main').outerHeight());
    }
}

function metaClone() {
    var newmeta = meta.clone();
    var navlang = lang.clone();
    nav.append(newmeta);
    nav.append(navlang);
}

function initNavClickHandler() {
    /* click handler */
    $('.navbar-toggler').on('click', function (event) {
        event.preventDefault();
        nav.toggleClass('show');
        body.toggleClass('prevent-scroll');
        event.stopPropagation();
    });

    $(document).on('click', '.nav-link.has-subnav', function (event) {
        if ($(window).width() < mobileSwitch) {
            var navLink = $(this);
            if (navLink.hasClass('open')) {
                if (event.pageX > $(window).width() - 50) {
                    event.preventDefault();
                    navLink.removeClass('open');
                }
            } else {
                event.preventDefault();
                navLink.addClass('open');
            }
        }
    });
}

function initNavSearch() {
    $('#search .btn[data-action="search"]').on('click', function (event) {
        if ($(window).width() > mobileSwitch) {
            if ($(this).attr('type') != "submit") {
                event.preventDefault();
                $(this).closest('.mxm_navigation').addClass('show-search');
                $(this).attr('type', 'submit');
                $(this).closest("#search").find('input').focus();
            }
        } else {
            $(this).attr('type', 'submit');
            $(this).click();
        }
    });

    $('#search .btn[data-action="close"]').on('click', function (event) {
        if ($(window).width() > mobileSwitch) {
            if ($(this).attr('type') != "submit") {
                event.preventDefault();
                if ($('.show-search').length) {
                    $(this).closest('.mxm_navigation').removeClass('show-search');
                    $('#search .btn[data-action="search"]').attr('type', 'button');
                }
            }
        }
    });
}

function initLogout() {
    $("a[data-logout]").on("click", function (event) {
        event.preventDefault();
        var item = $(this);
        var nonce = $('body').data('rest-nonce');
        var logoutUrl = item.data('logout');

        $.confirm({
            title: item.data('fc-title'),
            content: item.data('fc-content'),
            buttons: {
                cancel: {
                    text: item.data('fc-no'),
                    btnClass: 'mxm_button btn btn-link'
                },
                confirm: {
                    text: item.data('fc-yes'),
                    btnClass: 'mxm_button btn btn-primary',
                    action: function (confirmBtn) {
                        $.dialog({
                            title: item.data('fc-title'),
                            content:item.data('fc-success'),
                            icon: 'fal fa-spinner fa-spin',
                        });
                        $.ajax({
                                type: 'GET',
                                url: logoutUrl,
                                beforeSend: function (xhr) {
                                    if (nonce && nonce.length) {
                                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                                    }
                                }
                            })
                            .done(function (result) {
                                if (result.url.length) {
                                    window.location.href = result.url;
                                }
                            })
                            .fail(function (result) {
                                console.warn(result);
                            });
                    }
                }
            }
        });
    });
}